import { put, takeEvery, call } from "redux-saga/effects";
import * as actionTypes from "./constants";
// import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import endpoints from "../endpoints";
// import api from "../api";
import fmApi from "../APIWrapper";

// function* commonFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type: 'Web'
//       },
//       body: value.body ? value.body : null,
//     });
//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();

//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield put({ type: `${value.initAction}` });

//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });
//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({ type: `${value.failAction}`, error: err });
//     } else {
//     }
//   }
// }

// function* commonPostFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type: "Web",
//       },
//       body: value.body ? value.body : null,
//     });

//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();
//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield put({
//         type: `${value.initAction}`,
//       });
//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });
//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       if (err.status === 400) {
//         yield put({ type: `${value.failAction}`, error: err });
//         yield toast.error(`${endpoints.status400}`);
//       } else if (err.status === 500) {
//         yield put({ type: `${value.failAction}`, error: err });
//         yield toast.error(`${endpoints.status500}`);
//       } else {
//       }
//     }
//   }
// }

function* fetchOnboardingTotal() {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
    filter: "Total",
    type: "All",
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/apartment`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_TOTALONBOARDINGRESIDENTS_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_TOTALONBOARDINGRESIDENTS_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.FetchOnboardingApartmentApi, data);
    yield put({
      type: actionTypes.FETCH_TOTALONBOARDINGRESIDENTS_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_TOTALONBOARDINGRESIDENTS_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchOnboardingRecieved() {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
    filter: "Credit",
    type: "All",
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/apartment`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_RECIEVEDONBOARDINGRESIDENTS_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_RECIEVEDONBOARDINGRESIDENTS_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.FetchOnboardingApartmentApi, data);
    yield put({
      type: actionTypes.FETCH_RECIEVEDONBOARDINGRESIDENTS_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_RECIEVEDONBOARDINGRESIDENTS_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchOnboardingPending() {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
    filter: "Pending",
    type: "All",
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/apartment`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_PENDINGONBOARDINGRESIDENTS_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_PENDINGONBOARDINGRESIDENTS_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.FetchOnboardingApartmentApi, data);
    yield put({
      type: actionTypes.FETCH_PENDINGONBOARDINGRESIDENTS_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_PENDINGONBOARDINGRESIDENTS_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* updateApprovedResidents(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const Ownernumber = value?.value?.ownerisd + "-" + value?.value?.mobile || "";
  const Residentnumber =
    value?.value?.residentisd + "-" + value?.value?.residentNumber || "";
  const data = {
    societyId: `${fmsUser.society_id}`,
    apts: [
      {
        aptNo: value?.value?.appartment || "",
        residentName: value?.value?.residentName || "",
        residentEmail: value?.value?.residentEmail || "",
        residentPhone: `${Residentnumber}`,
        towerName: value?.value?.itemList?.towerName || "",
        ownerName: value?.value?.ownerName || "",
        ownerEmail: value?.value?.ownerEmail || "",
        ownerPhone: `${Ownernumber}`,
      },
    ],
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/addaptdetails`,
    //   method: "POST",
    //   sucessAction: actionTypes.UPDATE_TOTALONBOARDINGRESIDENTS_SUCCESS_ACTION,
    //   initAction: actionTypes.FETCH_TOTALONBOARDINGRESIDENTS_INIT_ACTION,
    //   toastMsg: "Apartment details updated successfully",
    //   failAction: actionTypes.UPDATE_TOTALONBOARDINGRESIDENTS_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.UpdateAppUsersApi, data);

    yield put({
      type: actionTypes.UPDATE_TOTALONBOARDINGRESIDENTS_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_TOTALONBOARDINGRESIDENTS_INIT_ACTION,
      payload: resJSON,
    });
    yield toast.success("Apartment details updated successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.UPDATE_TOTALONBOARDINGRESIDENTS_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* updatePendingResidents(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const Ownernumber = value?.value?.ownerisd + "-" + value?.value?.mobile || "";
  const Residentnumber =
    value?.value?.residentisd + "-" + value?.value?.residentNumber || "";
  const data = {
    societyId: `${fmsUser.society_id}`,
    apts: [
      {
        aptNo: value?.value?.appartment || "",
        residentName: value?.value?.residentName || "",
        residentEmail: value?.value?.residentEmail || "",
        residentPhone: `${Residentnumber}`,
        towerName: value?.value?.itemList?.towerName || "",
        ownerName: value?.value?.ownerName || "",
        ownerEmail: value?.value?.ownerEmail || "",
        ownerPhone: `${Ownernumber}`,
      },
    ],
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/addaptdetails`,
    //   method: "POST",
    //   sucessAction:
    //     actionTypes.UPDATE_PENDINGONBOARDINGRESIDENTS_SUCCESS_ACTION,
    //   initAction: actionTypes.FETCH_PENDINGONBOARDINGRESIDENTS_INIT_ACTION,
    //   toastMsg: "Apartment details updated successfully",
    //   failAction: actionTypes.UPDATE_PENDINGONBOARDINGRESIDENTS_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.UpdateAppUsersApi, data);

    yield put({
      type: actionTypes.UPDATE_PENDINGONBOARDINGRESIDENTS_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_PENDINGONBOARDINGRESIDENTS_INIT_ACTION,
      payload: resJSON,
    });
    yield toast.success("Apartment details updated successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.UPDATE_PENDINGONBOARDINGRESIDENTS_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* updateReceivedResidents(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const Ownernumber = value?.value?.ownerisd + "-" + value?.value?.mobile || "";
  const Residentnumber =
    value?.value?.residentisd + "-" + value?.value?.residentNumber || "";
  const data = {
    societyId: `${fmsUser.society_id}`,
    apts: [
      {
        aptNo: value?.value?.appartment || "",
        residentName: value?.value?.residentName || "",
        residentEmail: value?.value?.residentEmail || "",
        residentPhone: `${Residentnumber}`,
        towerName: value?.value?.itemList?.towerName || "",
        ownerName: value?.value?.ownerName || "",
        ownerEmail: value?.value?.ownerEmail || "",
        ownerPhone: `${Ownernumber}`,
      },
    ],
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/addaptdetails`,
    //   method: "POST",
    //   sucessAction:
    //     actionTypes.UPDATE_RECEIVEDONBOARDINGRESIDENTS_SUCCESS_ACTION,
    //   initAction: actionTypes.FETCH_RECIEVEDONBOARDINGRESIDENTS_INIT_ACTION,
    //   toastMsg: "Apartment details updated successfully",
    //   failAction: actionTypes.UPDATE_RECEIVEDONBOARDINGRESIDENTS_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.UpdateAppUsersApi, data);

    yield put({
      type: actionTypes.UPDATE_RECEIVEDONBOARDINGRESIDENTS_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_RECIEVEDONBOARDINGRESIDENTS_INIT_ACTION,
      payload: resJSON,
    });
    yield toast.success("Apartment details updated successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.UPDATE_RECEIVEDONBOARDINGRESIDENTS_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

export function* ApprovedResidentsActionWatcher() {
  yield takeEvery(
    actionTypes.FETCH_TOTALONBOARDINGRESIDENTS_INIT_ACTION,
    fetchOnboardingTotal
  );
  yield takeEvery(
    actionTypes.FETCH_RECIEVEDONBOARDINGRESIDENTS_INIT_ACTION,
    fetchOnboardingRecieved
  );
  yield takeEvery(
    actionTypes.FETCH_PENDINGONBOARDINGRESIDENTS_INIT_ACTION,
    fetchOnboardingPending
  );
  yield takeEvery(
    actionTypes.UPDATE_TOTALONBOARDINGRESIDENTS_INIT_ACTION,
    updateApprovedResidents
  );
  yield takeEvery(
    actionTypes.UPDATE_PENDINGONBOARDINGRESIDENTS_INIT_ACTION,
    updatePendingResidents
  );
  yield takeEvery(
    actionTypes.UPDATE_RECEIVEDONBOARDINGRESIDENTS_INIT_ACTION,
    updateReceivedResidents
  );
}
